import script from "./IncidentFormComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./IncidentFormComponent.vue?vue&type=script&setup=true&lang=ts"

import "./IncidentFormComponent.vue?vue&type=style&index=0&id=6c0b0bda&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c0b0bda"]])

export default __exports__